"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextBar = exports.ContextBarSpacer = exports.ContextBarItem = exports.CONTEXT_BAR_HEIGHT = void 0;
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
exports.CONTEXT_BAR_HEIGHT = 56;
const ItemWrapper = styled_components_1.default.div `
  height: 100%;
  margin: 0 ${polished_1.rem(4)};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
const Wrapper = styled_components_1.default.div `
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  height: ${({ theme }) => polished_1.rem(theme.contextBar.height)};
  background-color: ${({ theme }) => theme.contextBar.backgroundColor};
  padding: ${polished_1.rem(8)};
  display: flex;
  align-items: center;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.08);
  color: ${({ theme }) => theme.textColor};
  font-size: ${polished_1.rem(14)};
  z-index: 1;
`;
const Spacer = styled_components_1.default.div `
  flex: 1 0 0;
`;
exports.ContextBarItem = (props) => {
    return react_1.default.createElement(ItemWrapper, null, props.children ? props.children : react_1.default.createElement("div", null));
};
exports.ContextBarSpacer = () => {
    return react_1.default.createElement(Spacer, null);
};
exports.ContextBar = (props) => {
    return react_1.default.createElement(Wrapper, null, props.children);
};
exports.ContextBar.propTypes = {
    children: prop_types_1.default.node,
};
exports.ContextBarItem.propTypes = {
    children: prop_types_1.default.node,
};
exports.ContextBar.defaultProps = {
    children: react_1.default.createElement("div", null),
};
exports.ContextBarItem.defaultProps = {
    children: react_1.default.createElement("div", null),
};
exports.ContextBar.Spacer = exports.ContextBarSpacer;
exports.ContextBar.Item = exports.ContextBarItem;
exports.default = exports.ContextBar;
